<template>
  <v-progress-linear
    :active="loading"
    :color="color"
    :indeterminate="true"
    class="ma-0 pa-0"
    height="4"
    style="top: -2px;"
  ></v-progress-linear>
</template>

<script>
// @group Common
// ProgressBar component
  export default {
    name: 'ProgressBar',
    props: {
      //is progress linear loading
      loading: {
       // `true` / `false`
      type: Boolean,
       // The default value is: `false`
      default: false
      },
      //has color
      color: {
        type: String,
         // The default value is: `deep-purple accent-4`
        default: 'deep-purple accent-4'
      }
    },
  };
</script>

<style scoped>
.v-progress-linear {
  -moz-transform: scale(1, -1);
  -webkit-transform: scale(1, -1);
  -o-transform: scale(1, -1);
  -ms-transform: scale(1, -1);
  transform: scale(1, -1);
}
</style>